import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { Item, Tracking, Master, Reviews , User, Assignment } from '@providers/asset/index';
import { DetailItemPage,PicPage, DetailImagePage, ClassificationPage, FormReviewPage} from '../';

@Component({
  selector: 'page-assignment-result',
  templateUrl: 'page.html'
})
export class AssignmentResPage {

  List: any = [];
  location:any={};
  list_path:any=[];
  url_image='';
  keyword='';
  currentPage = 1;
  pageSize = 50;
  total_rows = 0;
  total_page = 0;
  params:any = {
    asset_classification_code:'',
    asset_location_id:'',
  };
  selectedClassification:any=[];
  panelSearch = false;
  akses:any={};

  assignment_id=0;
  assign_location_name='';
  project_code = '';
  project_title = '';
  
  constructor(
    public navCtrl: NavController,
    public itemApi: Item,
    public trackingApi: Tracking,
    public masterApi: Master,
    public userApi: User,
    public reviewApi: Reviews,
    public assignmentApi: Assignment,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public barcodeScanner:BarcodeScanner,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.akses = this.userApi.akses;

    this.url_image = itemApi.base_url+'/client/uploads/';
    console.log("akses =>",this.akses);

      this.assignment_id = this.navParams.get('assignment_id');
      this.params.asset_location_id = this.navParams.get('asset_location_id');
      this.getPath(this.navParams.get('location_path_id'));
      this.project_code = this.navParams.get('project_code');
      this.project_title = this.navParams.get('project_title');
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  showSearch(){
    this.panelSearch=true;
  }
  hideSearch(){
    this.panelSearch=false;
  }

  pilihClassification() {
    let myModal = this.modalCtrl.create(ClassificationPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      console.log(data.item);
      if(data.item){
        this.selectedClassification=data.item;
        this.params.asset_classification_code=data.item.classification_code;
        this.changeClassification();
      }
    });
    myModal.present();
  }
  changeClassification(){
    this.currentPage=1;
    this.getList()
  }
  changeLocation(){
    this.currentPage=1;
    this.getList()
  }

  first(){
    this.currentPage=1;
    this.getList()
  }
  last(){
    this.currentPage=this.total_page;
    this.getList()
  }
  next(){
    this.currentPage++;
    this.getList()
  }
  prev(){
    this.currentPage--;
    this.getList()
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = { 
      page:this.currentPage,
      pageSize:this.pageSize,
      get_result:true,
      assignment_id:this.assignment_id
    };
    if(this.assignment_id!=0){
      params.assignment_id=this.assignment_id;
    }
    if(this.keyword!=undefined){
      params.keyword=this.keyword;
    }
    if(this.params.asset_classification_code!=''){
      params.asset_classification_code=this.params.asset_classification_code;
    }

    let get:any;

    get = this.assignmentApi.getItem(params);
    get.subscribe((resp:any) => {
      this.List = resp.data;
      this.total_rows = resp.total_rows;
      this.total_page = this.total_rows/this.pageSize;
      this.total_page = Math.ceil(this.total_page);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  onInput(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getList();
  }

  onCancel(e){
    this.currentPage = 1;
    this.pageSize = 50;
    this.total_rows = 0;
    this.total_page = 0;
    this.getList();
  }

  getPath(location_path){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { location_path: location_path };
    
    this.masterApi.getLocation(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.list_path = resp.data;
      }else{
        
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_image+rec.generated_name,
      detail: rec
    });
    profileModal.present();
  }

  select(id) {
    let params : any = {id: id};
        params.assign = 1,
        params.assignment_id = this.assignment_id,
        params.assignment_result=true
      this.navCtrl.push(DetailItemPage, params);
  }

  detailPIC() {
    this.navCtrl.push(PicPage);
  }

  add_review(){
    this.navCtrl.push(FormReviewPage, {
      location_id   :this.location.id,
      location_name :this.location.location_name
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/assignment_result/page.ts